import React from 'react';
import { ClientDetails as ClientDetailsType } from '../models/invoice';

interface Props {
    client: ClientDetailsType;
    onChange: (field: string, value: string) => void;
    hiddenFields: { [key: string]: boolean };
    onToggleVisibility: (field: string) => void;
}

const ClientDetails: React.FC<Props> = ({ client, onChange, hiddenFields, onToggleVisibility }) => {
    const handleInput = (field: keyof ClientDetailsType, value: string) => {
        onChange(field, value);
    };

    return (
        <div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['name'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Pavadinimas / Vardas Pavardė
                    <input
                        type="checkbox"
                        checked={!hiddenFields['name']}
                        onChange={() => onToggleVisibility('name')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={client.name}
                    onChange={(e) => handleInput('name', e.target.value)}
                    placeholder="Klientas UAB"
                    style={styles.input}
                    disabled={hiddenFields['name']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['address'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Adresas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['address']}
                        onChange={() => onToggleVisibility('address')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={client.address}
                    onChange={(e) => handleInput('address', e.target.value)}
                    placeholder="Gatvės g. 2, Kaunas"
                    style={styles.input}
                    disabled={hiddenFields['address']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['registrationCode'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Įmonės kodas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['registrationCode']}
                        onChange={() => onToggleVisibility('registrationCode')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={client.registrationCode}
                    onChange={(e) => handleInput('registrationCode', e.target.value)}
                    placeholder="987654321"
                    style={styles.input}
                    disabled={hiddenFields['registrationCode']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['vatCode'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    PVM kodas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['vatCode']}
                        onChange={() => onToggleVisibility('vatCode')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={client.vatCode}
                    onChange={(e) => handleInput('vatCode', e.target.value)}
                    placeholder="LT987654321"
                    style={styles.input}
                    disabled={hiddenFields['vatCode']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['email'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    El. paštas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['email']}
                        onChange={() => onToggleVisibility('email')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="email"
                    value={client.email}
                    onChange={(e) => handleInput('email', e.target.value)}
                    placeholder="klientas@pastas.lt"
                    style={styles.input}
                    disabled={hiddenFields['email']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['phone'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Telefonas
                    <input
                        type="checkbox"
                        checked={!hiddenFields['phone']}
                        onChange={() => onToggleVisibility('phone')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="tel"
                    value={client.phone}
                    onChange={(e) => handleInput('phone', e.target.value)}
                    placeholder="+370 600 00000"
                    style={styles.input}
                    disabled={hiddenFields['phone']}
                />
            </div>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    formGroup: {
        marginBottom: '15px',
        position: 'relative', // For absolute positioning of toggle if needed
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '5px',
        fontWeight: 'bold',
        fontSize: '0.9rem',
        color: '#555',
    },
    input: {
        width: '100%',
        padding: '8px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontSize: '1rem',
    },
    hiddenField: {
        opacity: 0.5,
        backgroundColor: '#f0f0f0',
        pointerEvents: 'none', // Disable interactions
    },
    visibilityToggle: {
        marginLeft: 'auto', // Push to the right
        marginRight: '5px',
        width: '16px',
        height: '16px',
        cursor: 'pointer',
        pointerEvents: 'all', // Re-enable interaction for the toggle itself
    }
};

export default ClientDetails;
